import { render, staticRenderFns } from "./Baby.vue?vue&type=template&id=cc6eef0e&"
import script from "./Baby.vue?vue&type=script&lang=js&"
export * from "./Baby.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Baby.vue"
export default component.exports